import type { FetchParams, ParamType } from '@/api/types.ts'
import UserApi from '@/api/User'
import { queryOptions, useQuery } from '@tanstack/react-query'

export function useFetchUser(params: FetchParams) {
  return useQuery({
    queryKey: ['fetch-user', params],
    queryFn: () => UserApi.fetch([], params),
  })
}

export function getUserQueryOptions(id: ParamType) {
  return queryOptions({
    queryKey: ['get-user', id],
    queryFn: () => UserApi.get(id),
  })
}

export function useGetUser(id: ParamType) {
  return useQuery(getUserQueryOptions(id))
}

export function useFetchUserGroups(id: ParamType, params: FetchParams) {
  return useQuery({
    queryKey: ['fetch-user-groups', id, params],
    queryFn: () => UserApi.fetchUserGroups(id, params),
  })
}

export const getMeOptions = () =>
  queryOptions({
    queryKey: ['get-me'],
    queryFn: () => UserApi.getSelf(),
  })

export function useGetMe() {
  return useQuery(getMeOptions())
}
